import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const DcReturnView = () => {
  useAuthRedirect();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const startYear = 2007;

  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  /////////////////////////////////////////////////////////////     
            //✅ Permission checks (safe even if perms not yet loaded; will be false)
            const canView  = hasPermission("D.C Returns", "view");
            const canEntry = hasPermission("D.C Returns", "entry");
            const canDel = hasPermission("D.C Returns", "del");
            /////////////////////////////////////////////////////////////
       

  useEffect(() => {
    fetchData();
  }, [ selectedYear, selectedMonth]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/dcReturn_list", {
        params: {  month: selectedMonth, year: selectedYear, branch: branch }
      });

      console.log("API Response:", response.data.purchaseOrderList);
      setData(response.data.purchaseOrderList);
      setFilteredData(response.data.purchaseOrderList);
    } catch (error) {
      console.error("Error fetching purchaseOrderList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.dcreturnheader_number || "").toLowerCase().includes(term) ||
       String(item.dcreturnheader_yourDcNumber || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`https://rfs2.infraconsoft.net.in/api/dcReturn_delete/${id}`);
          setData(data.filter((item) => item.dcreturnheader_number !== id));
          setFilteredData(filteredData.filter((item) => item.dcreturnheader_number !== id));

          Swal.fire({
            title: "Deleted!",
            text: "Your record has been deleted.",
            icon: "success"
          });
        } catch (error) {
          console.error("Error deleting vehicle position:", error);
          Swal.fire({
            title: "Error!",
            text: "Failed to delete vehicle position.",
            icon: "error"
          });
        }
      }
    });
  };

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Delivery Challan Return Note</h2>
          <Time />
        </section>



        {/* Month & Year Selection */}
        <div className="month-year-container">
          <p className="title">Select your Month & Year:</p>

          <div className="select-container">
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(12).keys()].map(i => (
                <option key={i + 1} value={i + 1}>
                  {(i + 1).toString().padStart(2, "0")}
                </option>
              ))}
            </select>

            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(currentYear - startYear + 1).keys()].map(i => (
                <option key={startYear + i} value={startYear + i}>
                  {startYear + i}
                </option>
              ))}
            </select>
          </div>



          <button
  className="custom-button"
  onClick={() => {
    window.location.href = '/inventory/dcReturnView';
  }}
>
  View All
</button>
        </div>

        {/* Add New Button */}
        {canEntry && (
        <div className="add-new-container">
          <Link to={`/inventory/addDcReturn`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add New
            </button>
          </Link>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by DC No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>D.C Return No</th>
                <th>Date</th>
                <th>Party D.C Number</th>
                <th>Date</th>
                <th>Our D.C Number</th>
                <th>Date</th>
                <th>No. of Packs</th>
                <th>Vehicle No</th>
                {canDel && (
                <th>Delete</th>
                )}
                <th>Print</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/inventory/dcReturnViewSingle/${item.dcreturnheader_number}`}>
                        {item.dcreturnheader_number}
                      </Link>
                    </td>
                    <td>{new Date(item.dcreturnheader_date).toLocaleDateString()}</td>
                    <td>{item.dcreturnheader_yourDcNumber}</td>
                    <td>{new Date(item.dcreturnheader_yourDcDate).toLocaleDateString()}</td>
                    <td>{item.dcreturnheader_OurDcNumber}</td>
                    <td>{new Date(item.dcreturnheader_OurDcDate).toLocaleDateString()}</td>
                    <td>{item.dcreturnheader_noofPacks}</td>
                    <td>{item.dcreturnheader_vehicleNumber}</td>
                    {canDel && (
                    <td className="del">
                      <i className="fa-solid fa-trash-can " onClick={() => handleDelete(item.dcreturnheader_number)}></i>
                    </td>
                    )}
                   <td className="edit">
                        <Link to={`/inventory/dcReturnPrint/${item.dcreturnheader_number}`} target="_blank">
                        <i class="fa-solid fa-print"></i>
                        </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default DcReturnView;
